<div class="component d-block position-relative full-width full-height">
    <canvas baseChart
            [datasets]="datasets"
            [options]="chartOptions"
            chartType="scatter"
    >
    </canvas>
</div>
